export default __webpack_public_path__ + "static/media/service2.9db86ea6.jpg";